module.exports = __webpack_public_path__ + "static/media/mode-2040.cf7e5031.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-2040.svg
// module id = 1033
// module chunks = 2